import loadable from "utils/loadable";

export const HalamanUploadVideos = loadable(() => import("./index"));
export const PopupData = loadable(() => import("./PopupData"));
